













import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import Searchbox from '../Searchbox.vue';
import SearchboxV2 from './SearchboxV2.vue';

@Component({
  name: 'SearchboxWrapper',
  components: {
    Searchbox,
    SearchboxV2,
  },
})
export default class SearchboxWrapper extends Vue {
  @Prop() jobAlertId;
  $wlToastr: any;
  isFilterDataFetched: boolean = false;
  callV2SearchBox: boolean = false;
  filtersData: any = [];

  getTranslatedValue(key, defaultValue) {
    const lang = this.$cookies.get('userLang') || 'en';
    if (lang === 'en') return defaultValue;
    const label = this.$t(key).toString();
    return label.indexOf(key) >= 0 ? defaultValue || label : label;
  }

  async mounted() {
    if (vxm.jobs.filterForJobAlerts) {
      this.isFilterDataFetched = true;
      const filterDataResponse = vxm.jobs.JobAlertFilterURL;
      this.filtersData = filterDataResponse;
      this.callV2SearchBox = this.filtersData
        ? this.filtersData.jobFilterMetaDataVOList &&
          this.filtersData.jobFilterMetaDataVOList.length > 0
        : false;

      // vxm.jobs.setJobAlertFilterURL('');
    } else {
      try {
        if (vxm.utility.PreventFilterMetaDataAPI) {
          vxm.utility.setPreventFilterMetaDataAPI(false);
          this.isFilterDataFetched = true;
          this.callV2SearchBox = !!vxm.jobs.FilterMetaData.length;
          this.filtersData = {
            jobFilterMetaDataVOList: vxm.jobs.FilterMetaData,
          };
          return;
        }
        const filterDataResponse = await vxm.jobs.fetchFiltersData();
        this.filtersData =
          filterDataResponse && filterDataResponse.data
            ? filterDataResponse.data
            : null;

        if (this.filtersData && this.filtersData.jobFilterMetaDataVOList) {
          this.filtersData.jobFilterMetaDataVOList.forEach((filter) => {
            filter.label = this.getTranslatedValue(filter.name, filter.label);
          });
        }

        this.callV2SearchBox = this.filtersData
          ? this.filtersData.jobFilterMetaDataVOList &&
            this.filtersData.jobFilterMetaDataVOList.length > 0
          : false;
        if (!this.callV2SearchBox) {
          await vxm.jobs.getJobFilters(vxm.jobs.BrandingInfo.companycode);
          await vxm.jobs.getCustomFilters(vxm.jobs.BrandingInfo.companycode);
          if (!this.$route.query.jobalertid && !this.$route.params.filterUrl) {
            let resp = await vxm.jobs.loadJobs().catch((err) => {});
            if (resp.data && resp.data.errorCode === '1111') {
              this.$wlToastr('error', resp.data.errorMessage);
            }
          }
        }
        this.isFilterDataFetched = true;
      } catch (ex) {
        this.callV2SearchBox = false;
        await vxm.jobs.getJobFilters(vxm.jobs.BrandingInfo.companycode);
        await vxm.jobs.getCustomFilters(vxm.jobs.BrandingInfo.companycode);
        if (!this.$route.query.jobalertid) {
          let resp = await vxm.jobs.loadJobs().catch((err) => {});
          if (resp.data && resp.data.errorCode === '1111') {
            this.$wlToastr('error', resp.data.errorMessage);
          }
        }
        this.isFilterDataFetched = true;
      }
    }
  }
}
